module.exports = "https://deal.freetls.fastly.net/consumer/common/media/step-1.ad43e8cd.mp4";